<template>
  <el-dialog class="dialog-edit-system" :title="title" :visible.sync="visible" width="1150px">
    <ConfigForms ref="form" labelWidth="110px" :formItems="formItems" :data="formData" inline>
      <el-form-item label="配置" style="width: 100%;">
        <el-button class="base-config__add" type="text" icon="el-icon-plus" size="small" @click="addConfigLine">新增</el-button>
        <SystemConfig ref="cfgRef" :cid="formData.id" :configLines="configLines" @del="delConfigLine"></SystemConfig>
      </el-form-item>
    </ConfigForms>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';
import { statusOptions, systemConfigOptions } from '../../config/system';
import SystemConfig from './SystemConfig.vue';

const formItems = [
  { type: 'text', label: '配置名称', required: true, key: 'name' },
  { type: 'select', label: '配置类型', required: true, disabled: true, key: 'type', options: systemConfigOptions },
  { type: 'textarea', label: '配置值', required: false, key: 'value' }, // 上传图片
  { type: 'select', label: '状态', required: true, key: 'status', options: statusOptions }
]

export default {
  name: 'EditSystem',
  emit: ['close'],
  components: { ConfigForms, SystemConfig },
  data() {
    return {
      visible: false,
      formItems,
      formData: {},
      configLines: [{}]
    };
  },
  watch: {
  },
  computed: {
    isEdit() {
      return !!this.formData
    },
    title() {
      return this.isEdit ? '编辑配置' : '新增配置'
    }
  },
  created() {

  },
  methods: {
    async addConfigLine() {
      try {
        await this.$refs.cfgRef.checkLastConfigLine()
        this.configLines.push({})
      } catch (error) {
        this.$message.error('请先完成上一配置') 
      }
    },
    delConfigLine(index) {
      this.configLines.splice(index, 1)
    },
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = null
      this.configLines = [{}]
      if (row) {
        this.formData = {}
        this.formItems.forEach(item => {
          this.formData[item.key] = row[item.key]
        })
        this.configLines = row.baseConfig ? row.baseConfig : [{}]
        this.formData.id = row.id
      }
      this.visible = true
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const baseConfig = await this.$refs.cfgRef.validateAllConfig()
        const data = { ...form, baseConfig }
        this.$emit('sure', { isEdit: this.isEdit, data })
      } catch (error) {
        console.error('sure error:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-system {
  /deep/ .el-date-editor.el-input {
    width: 200px;
  }

  /deep/ .el-dialog__header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
  }

  /deep/ .el-dialog__footer {
    position: sticky;
    bottom: 0;
    background: white;
  }

  .base-config__add {
    position: absolute;
    top: -35px;
    left: 110px;
  }

  .base-config__line {
    display: flex;
    align-items: center;
    background-color: #0001;
    padding: 15px 0 0;
    border-radius: 10px;
    margin-bottom: 10px;

    /deep/ .el-form-item {
      margin-bottom: 20px;
    }
  }

  .base-config__btns {
    /deep/ .el-button {
      margin-left: 0;
      margin-right: 15px;
    }
  }
}
</style>
